import React from "react";
import styled, { css, ThemeProvider } from "styled-components";
import { Style } from "../../styles";
import Icon from "../../components/Icons/Icon";
import { WithTranslation, withTranslation } from "react-i18next";
import Header from "../../components/Inbox/Header";
import HeaderTitle from "../../components/Inbox/HeaderTitle";
import HeaderActions from "../../components/Inbox/HeaderActions";
import HeaderAction from "../../components/Inbox/HeaderAction";
import DetailsSection from "../../components/Inbox/DetailsSection";
import {
  ConversationMessage,
  ConversationMessageAuthorType,
  ConversationState, Conversation as ConversationType, CurrentUser, User, Widget,
  ConversationMessageType,
  ConversationChannelEvent,
  ConversationChannelEventType,
  ConversationChannelAdminTypingEvent,
  PublicLocale
} from "../../types";
import { ActiveStorageController, ConversationsController } from "../../controllers";
import { RouteComponentProps } from "react-router-dom";
import ActionCableConsumer from "../../consumers/ActionCableConsumer";
import { connect } from "react-redux";
import { AppState } from "../../store";
import { AnyAction, Dispatch } from "redux";
import ResourceCreatablePowerSelect from "../../components/Form/ResourceCreatablePowerSelect";
import moment from "../../utilities/Moment";
import ConversationPart from "../../widget/components/Messenger/Conversations/ConversationPart";
import Message from "../../widget/components/Messenger/Conversations/Message";
import DEFAULT_THEME from "../../widget/styles/defaulTheme";
import Badge from "../../components/Badge/Badge";
import Loader from "../../widget/components/Loader/Loader";
import Utils from "../../utilities/Utils";
import Popover from "../../components/Popover/Popover";
import EmojiPopover from "../../widget/components/Popover/EmojiPopover";
import Dropzone from "react-dropzone";
import PreviewModal from "../../widget/components/Modals/PreviewModal";
import GiphyPopover from "../../components/Inbox/GiphyPopover";
import MessageTypePopover from "../../components/Inbox/MessageTypePopover";
import { readableColor } from "polished";
import { showInsertArticleModal } from "../../store/modals/actions";
import SimpleTooltip from '@/components/Tooltips/SimpleTooltip'

const LoaderContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  position: relative;
`

const ConversationContainer = styled.div`
	display: flex;
	flex-direction: row;
	background-color: white;
	flex: 1;
	min-width: 400px;
	width: 100%;
`

const ConversationContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
  overflow: hidden;
`

const ConversationWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
  flex-grow: 1;
  flex-shrink: 0;
	padding: 16px 20px 40px 20px;
  height: auto;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
`

const ConversationFooterWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;
	border: 1px solid ${Style.color.border};
	border-radius: 12px;
	word-break: break-word;
	color: #0d0b0b;
	overflow-wrap: break-word;
	overflow-x: hidden;
`

const ConversationFooter = styled.div<{ messageType: ConversationMessageType }>`
	padding: 0 16px;

  ${props => props.messageType === ConversationMessageType.NOTE && css`
    ${ConversationFooterWrapper} {
      background: #feecaf;
      border-color: #e9eae6;

      textarea {
        background: #feecaf;
      }
    }

    ${ConversationFooterInput} {
      background: #feecaf;
    }
  `}
`



const ConversationFooterTop = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px 8px 0 8px;
	margin-bottom: 8px;
`

const ConversationMessageTypeOption = styled.div<{ active: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 0 4px;
	color: rgb(26, 26, 26);
	border: 1px solid transparent;
	border-radius: 12px;
	cursor: pointer;
	gap: 4px;
	font-size: 14px;
	font-weight: bold;

	&:hover, &:focus {
		border-color: rgb(233, 234, 230);
	}

	${props => props.active && css`
		border-color: rgb(233, 234, 230);

		svg:last-child {
			transform: rotate(180deg);
		}
	`}

	svg {
		width: 14px;
		height: 14px;
	}
`

const ConversationFooterInput = styled.textarea`
	border: none;
	outline: none;
	box-shadow: none;
	margin: 4px 8px;
	padding: 6px 7px;
	min-height: 64px;
  transition: none;

	&:focus {
		border: none;
		outline: none;
		box-shadow: none;
	}
`

const ConversationFooterActions = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0 8px 8px 8px;
`

const ConversationFooterLeftActions = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`

const ConversationFooterRightActions = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`

const SendButton = styled.div<{ disabled?: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	background: black;
	height: 32px;
	color: white;
	border-radius: 16px;
	font-weight: bold;
  cursor: pointer;

  ${props => props.disabled && css`
    background-color: rgba(9, 14, 21, 0.1);
    color: rgb(214, 214, 214);
    cursor: not-allowed;

    svg {
      fill: currentColor;
    }
  `}



	span {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		padding: 8px;
		cursor: pointer;
	}

	svg {
		width: 14px;
		height: 14px;
	}
`

const ConversationFooterAction = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 32px;
	width: 32px;
	min-height: 32px;
	min-width: 32px;
	cursor: pointer;

	&:hover {
		svg {
			color: #e35712;
		}

		i {
			color: #e35712;
		}
	}

	svg {
		width: 16px;
		height: 16px;
	}

	i {
		font-size: 16px;
	}
`


const ConversationDetails = styled.div<{ active: boolean, mobileActive: boolean }>`
	display: flex;
	flex-direction: column;
	border-left: 1px solid ${Style.color.border};
	flex-basis: calc(40% + 0px);
	min-width: 300px;
	transition: transform .25s ease-in-out;
  background: white;

	${props => !props.active && css`
		transform: translateX(100%);
		display: none;
	`}

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    min-width: initial;
    width: 100%;
    flex-basis: initial;
    border-left: none;
    transform: none;

    ${props => props.mobileActive && css`
      display: flex;
    `}
  }
`

const DetailsSectionItem = styled.div<{ vertical?: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	height: 32px;

  ${props => props.vertical && css`
    flex-direction: column;
    align-items: flex-start;
    height: initial;
  `}
`

const DetailsSectionItemProperty = styled.div`
	font-size: 14px;
	color: #646462;
	width: 40%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

const DetailsSectionItemValue = styled.div<{ overflowVisible?: boolean }>`
	color: rgb(26, 26, 26);
	width: 100%;
	padding: 0 4px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;

  ${props => props.overflowVisible && css`
    overflow: visible;
  `}
`

interface IStateToProps {
  currentUser: CurrentUser
}
interface IDispatchToProps {
  showInsertArticleModal: typeof showInsertArticleModal
}

type IProps = {

} & IStateToProps & IDispatchToProps & WithTranslation & RouteComponentProps<{ id: string }>

interface IState {
  didInitialLoad: boolean
  widget: Widget
  conversation: ConversationType
  messageType: ConversationMessageType
  message: string
  inputFocused: boolean
  userScrolled?: boolean
  conversationDetailsMenuActive: boolean
  conversationDetailsMobileMenuActive: boolean
  messageTypePopoverActive: boolean
  emojiPopoverActive: boolean
  giphyPopoverActive: boolean
  previewUrl: string

}

class Conversation extends React.Component<IProps, IState> {
  private wrapper: React.RefObject<HTMLDivElement> = React.createRef()
  private messageInput: React.RefObject<HTMLTextAreaElement> = React.createRef()
  private cable: ActionCable.Channel | null = null
  private TYPING_DELAY = 3000

  constructor(props: IProps) {
    super(props)

    this.state = {
      didInitialLoad: false,
      widget: null,
      conversation: null,
      messageType: ConversationMessageType.TEXT,
      message: '',
      inputFocused: false,
      conversationDetailsMenuActive: true,
      conversationDetailsMobileMenuActive: false,
      messageTypePopoverActive: false,
      emojiPopoverActive: false,
      giphyPopoverActive: false,
      previewUrl: null,
    }

    this.fetchConversationView = this.fetchConversationView.bind(this)
    this.markConversationAsRead = this.markConversationAsRead.bind(this)
    this.debouncedMarkConversationAsRead = Utils.debounce(this.markConversationAsRead.bind(this), 500)
    this.navigateToInbox = this.navigateToInbox.bind(this)
    this.scrollToEnd = this.scrollToEnd.bind(this)
    this.onToggleConversationDetailsMenu = this.onToggleConversationDetailsMenu.bind(this)
    this.onMobileBackClick = this.onMobileBackClick.bind(this)
    this.onTogglePriority = this.onTogglePriority.bind(this)
    this.onToggleClosedClick = this.onToggleClosedClick.bind(this)
    this.onConversationAssigneeChange = this.onConversationAssigneeChange.bind(this)
    this.onMessageChange = this.onMessageChange.bind(this)
    this.onMessageKeyDown = this.onMessageKeyDown.bind(this)
    this.onMessageInputFocus = this.onMessageInputFocus.bind(this)
    this.onMessageInputBlur = this.onMessageInputBlur.bind(this)
    this.onScroll = Utils.debounce(this.onScroll.bind(this), 150)
    this.focusMessageInput = this.focusMessageInput.bind(this)
    this.onMessageTypePopoverToggle = this.onMessageTypePopoverToggle.bind(this)
    this.onMessageTypePopoverClose = this.onMessageTypePopoverClose.bind(this)
    this.onMessageTypeChange = this.onMessageTypeChange.bind(this)
    this.onEmojiPopoverToggle = this.onEmojiPopoverToggle.bind(this)
    this.onEmojiPopoverClose = this.onEmojiPopoverClose.bind(this)
    this.onEmojiSelect = this.onEmojiSelect.bind(this)
    this.onGiphyPopoverToggle = this.onGiphyPopoverToggle.bind(this)
    this.onGiphyPopoverClose = this.onGiphyPopoverClose.bind(this)
    this.onGiphySelect = this.onGiphySelect.bind(this)
    this.onInsertArticleClick = this.onInsertArticleClick.bind(this)
    this.onAttachmentDrop = this.onAttachmentDrop.bind(this)
    this.onPreviewAttachmentClick = this.onPreviewAttachmentClick.bind(this)
    this.onPreviewAttachmentClose = this.onPreviewAttachmentClose.bind(this)
    this.onMessageSendClick = this.onMessageSendClick.bind(this)
    this.sendMessage = this.sendMessage.bind(this)

    this.onActionCableConnected = this.onActionCableConnected.bind(this)
    this.onActionCableDisconnected = this.onActionCableDisconnected.bind(this)
    this.onActionCableReceived = this.onActionCableReceived.bind(this)
    this.onActionCableSubscriptionInitialised = this.onActionCableSubscriptionInitialised.bind(this)
    this.sendTypingEvent = this.sendTypingEvent.bind(this)
  }

  componentDidMount(): void {
    this.fetchConversationView()
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    const { conversation: currentStateConversation } = this.state
    const { conversation: previousStateConversation } = prevState

    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.fetchConversationView()
      return
    }

    if (currentStateConversation?.id && !currentStateConversation?.admin_read) this.debouncedMarkConversationAsRead()

    if (currentStateConversation && currentStateConversation?.id === previousStateConversation?.id) {
      // When state changes to closed from any other state, navigate to inbox
      if (currentStateConversation.state !== previousStateConversation?.state && currentStateConversation.state === ConversationState.CLOSED) {
        this.navigateToInbox()
      }
    }
  }

  async fetchConversationView() {
    const { match: { params: { id } } } = this.props

    try {
      this.setState({
        didInitialLoad: false,
        widget: null,
        conversation: null,
        userScrolled: false,
      })

      const {
        conversation,
        widget,
      } = await ConversationsController.getConversationView(id)

      this.setState({
        widget: widget,
        conversation: conversation,
        didInitialLoad: true,
      }, () => {
        setTimeout(this.scrollToEnd, 500)
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  async markConversationAsRead() {
    const { conversation } = this.state

    if (conversation?.id && !conversation.admin_read) {
      try {
        const updatedConversation = await ConversationsController.read(conversation.id)
        this.setState({ conversation: updatedConversation })
      } catch (ex) {
        console.error(ex)
      }
    }
  }

  debouncedMarkConversationAsRead() {
    this.markConversationAsRead()
  }

  navigateToInbox() {
    const { pathname } = this.props.location;
    const parentPath = pathname.split('/').slice(0, -1).join('/') || '/';
    this.props.history.push(parentPath);
  }

  onActionCableConnected() {
    console.log('[Conversation] connected')
  }

  onActionCableDisconnected() {
    console.log('[Conversation] Disconnected')
  }

  onActionCableReceived(event: ConversationChannelEvent) {
    console.log('[Conversation] received event', event)
    const { conversation } = this.state

    switch (event.type) {
      case ConversationChannelEventType.CONVERSATION_CREATE:
        const { conversation: newConversation } = event.data

        if (conversation?.id === newConversation.id) {
          this.setState({ conversation: newConversation })
        }
        break
      case ConversationChannelEventType.CONVERSATION_UPDATE:
        const { conversation: updatedConversation } = event.data

        if (conversation?.id === updatedConversation.id) {
          this.setState({ conversation: updatedConversation })
        }

        break
      case ConversationChannelEventType.CONVERSATION_DELETE:
        const { conversation_id } = event.data
        if (conversation?.id === conversation_id) {
          this.navigateToInbox()
        }
        break
      case ConversationChannelEventType.USER_TYPING:
        const { typing } = event.data

        if (typing) {
          if (conversation?.messages?.some(message => message.type === ConversationMessageType.TYPING)) return

          const typingMessage: ConversationMessage = {
            type: ConversationMessageType.TYPING,
            client_assigned_id: Utils.uuid(),
          }

          this.setState({
            conversation: {
              ...conversation,
              messages: [...(conversation?.messages || []), typingMessage]
            }
          }, this.scrollToEnd)
        } else {
          const messages = conversation?.messages || []
          this.setState({
            conversation: {
              ...conversation,
              messages: messages.filter(message => message.type !== ConversationMessageType.TYPING)
            }
          }, this.scrollToEnd)
        }
    }
  }

  onActionCableSubscriptionInitialised(cable: ActionCable.Channel) {
    this.cable = cable
  }

  sendTypingEvent(typing: boolean, delayed: boolean = false) {
    setTimeout(() => {
      const event: ConversationChannelAdminTypingEvent = {
        type: ConversationChannelEventType.ADMIN_TYPING,
        data: { typing: typing }
      }
      this.cable?.send(event)
    }, delayed ? this.TYPING_DELAY : 0)
  }

  onToggleConversationDetailsMenu() {
    this.setState({
      conversationDetailsMenuActive: !this.state.conversationDetailsMenuActive,
      conversationDetailsMobileMenuActive: !this.state.conversationDetailsMobileMenuActive,
    })
  }

  onMobileBackClick() {
    this.props.history.goBack()
  }

  async onTogglePriority() {
    const { conversation } = this.state

    try {
      const cacheConversation = { ...conversation, priority: !conversation.priority }
      const updatedConversation = await ConversationsController.update({ ...cacheConversation });

      this.setState({ conversation: updatedConversation })
    } catch (ex) {
      console.error(ex)
    }
  }

  async onToggleClosedClick() {
    const { conversation } = this.state
    try {
      const updatedConversation = { ...conversation, state: conversation.state === ConversationState.OPEN ? ConversationState.CLOSED : ConversationState.OPEN }
      await ConversationsController.update({ ...updatedConversation })
    } catch (ex) {
      console.error(ex)
    }
  }

  async onConversationAssigneeChange(assigneeId?: string, assignee?: User) {
    try {
      const { conversation } = this.state

      const updatedConversation: ConversationType = {
        ...conversation,
        assignee: assignee || null,
        assignee_id: assigneeId || null
      }

      this.setState({ conversation: updatedConversation })
      await ConversationsController.update({ ...updatedConversation })
    } catch (ex) {
      console.error(ex)
    }
  }

  focusMessageInput() {
    if (this.messageInput.current) this.messageInput.current.focus()
  }

  onMessageChange(e) {
    this.setState({ message: e.target.value })
  }

  onMessageKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      this.onMessageSendClick()
    }
  }

  onMessageInputFocus() {
    this.sendTypingEvent(true)
    this.setState({ inputFocused: true })
  }

  onMessageInputBlur() {
    this.sendTypingEvent(false, true)
    this.setState({ inputFocused: false })
  }

  onScroll() {
    if (!this.wrapper.current) return

    const { scrollTop, scrollHeight, clientHeight } = this.wrapper.current
    const userScrolled = scrollTop + clientHeight < scrollHeight - 50

    this.setState({ userScrolled: userScrolled })
  }

  async onMessageSendClick() {
    const { message, messageType } = this.state
    if (message.length === 0) return
    const { match: { params: { id } } } = this.props

    // @ts-ignore
    const conversationMessage: ConversationMessage = {
      type: messageType,
      content: message,
    }

    this.sendMessage(conversationMessage).catch(console.error)
  }

  async sendMessage(message: ConversationMessage) {
    const { match: { params: { id } } } = this.props
    let { conversation } = this.state

    const conversationMessage: ConversationMessage = {
      ...message,
      author: { type: ConversationMessageAuthorType.USER, },
      client_assigned_id: Utils.uuid(),
    }

    try {
      this.setState({
        conversation: {
          ...conversation,
          messages: [...(conversation?.messages || []), conversationMessage]
        },
        messageType: ConversationMessageType.TEXT,
        message: ''
      }, this.scrollToEnd)

      if (id) {
        const updatedConversation = await ConversationsController.reply(conversation.id, conversationMessage)
        conversation = updatedConversation
      }

      this.setState({ conversation: conversation })
    } catch (ex) {
      console.error(ex)
    } finally {
      this.sendTypingEvent(false, true)
    }
  }

  onMessageTypePopoverToggle() {
    this.setState({ messageTypePopoverActive: !this.state.messageTypePopoverActive })
  }

  onMessageTypePopoverClose() {
    this.setState({ messageTypePopoverActive: false })
  }

  onMessageTypeChange(type: ConversationMessageType) {
    this.setState({
      messageType: type,
      message: '',
      messageTypePopoverActive: false,
    })
  }

  onEmojiPopoverToggle() {
    this.setState({ emojiPopoverActive: !this.state.emojiPopoverActive })
  }

  onEmojiPopoverClose() {
    this.setState({ emojiPopoverActive: false })
  }

  onEmojiSelect(emoji: any) {
    const { message } = this.state

    this.setState({
      emojiPopoverActive: false,
      message: [message, emoji.native].join(' ').trim()
    }, this.focusMessageInput)
  }

  onGiphyPopoverToggle() {
    this.setState({ giphyPopoverActive: !this.state.giphyPopoverActive })
  }

  onGiphyPopoverClose() {
    this.setState({ giphyPopoverActive: false })
  }

  onGiphySelect(url: string) {
    this.setState({ giphyPopoverActive: false }, this.focusMessageInput)

    this.sendMessage({
      type: ConversationMessageType.GIF,
      url: url
    })
  }

  onInsertArticleClick() {
    const { widget, conversation } = this.state

    if (!widget.help_center_id) return

    requestAnimationFrame(() => {
      this.props.showInsertArticleModal({
        helpCenterId: widget.help_center_id,
        locale: conversation.user_data?.locale as PublicLocale || widget.locale,
        onSubmit: (helpCenterId, locale, article) => {
          this.sendMessage({
            type: ConversationMessageType.ARTICLE,
            help_center_id: helpCenterId,
            locale: locale,
            article_id: article.id,
          })
        }
      })
    })
  }

  async onAttachmentDrop(acceptedFiles: File[]) {
    const acceptedFile = acceptedFiles[0]

    try {
      const blob = await ActiveStorageController.uploadPromise(acceptedFile)

      const reader = new FileReader()
      const attachmentUrl = await new Promise<string>((resolve, reject) => {
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = reject
        reader.readAsDataURL(acceptedFile)
      })

      this.sendMessage({
        type: ConversationMessageType.ATTACHMENT,
        attachment: blob.signed_id,
        attachment_file_name: acceptedFile.name,
        attachment_content_type: acceptedFile.type,
        attachment_file_size: acceptedFile.size,
        attachment_url: attachmentUrl
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  onPreviewAttachmentClick(url: string) {
    this.setState({ previewUrl: url })
  }

  onPreviewAttachmentClose() {
    this.setState({ previewUrl: null })
  }

  scrollToEnd(behaviour: ScrollBehavior = 'smooth') {
    if (this.state.userScrolled) return
    requestAnimationFrame(() => {
      if (this.wrapper.current) {
        this.wrapper.current.scrollTo({
          top: this.wrapper.current.scrollHeight,
          behavior: behaviour
        })
      }
    })
  }

  getMessagesGroupedByDate(): { [date: string]: ConversationMessage[] } {
    const { conversation } = this.state
    if (!conversation || !conversation.messages) {
      return {}
    }

    const messagesByDate = conversation.messages.reduce((acc, message) => {
      const date = moment(message.created_at).format('YYYY-MM-DD')
      if (!acc[date]) acc[date] = []
      acc[date].push(message)
      return acc
    }, {})

    return messagesByDate
  }

  getTheme() {
    const { widget } = this.state

    if (!widget) return DEFAULT_THEME

    return {
      ...DEFAULT_THEME,
      color: {
        action: widget.action_color,
        actionText: readableColor(widget.action_color),
        background: widget.background_color,
        backgroundText: readableColor(widget.background_color)
      }
    }
  }

  render() {
    const { t, currentUser } = this.props
    const {
      conversation,
      conversationDetailsMenuActive,
      conversationDetailsMobileMenuActive,
      widget,
      messageType,
      message,
      messageTypePopoverActive,
      emojiPopoverActive,
      giphyPopoverActive,
      previewUrl,
    } = this.state

    if (!conversation) {
      return (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      )
    }

    const groupedMessages = this.getMessagesGroupedByDate()

    return (
      <>
        <ThemeProvider theme={this.getTheme()}>
          <ActionCableConsumer
            channel={{ channel: 'ConversationChannel', id: conversation.id }}
            onConnected={this.onActionCableConnected}
            onDisconnected={this.onActionCableDisconnected}
            onReceived={this.onActionCableReceived}
            subscriptionHandler={this.onActionCableSubscriptionInitialised}
          >
            <ConversationContainer>
              <ConversationContent>
                <Header>
                  <HeaderTitle>
                    <SimpleTooltip content={conversation.priority ? t('Conversation::Remove priority') : t('Conversation::Mark priority')}>
                      <HeaderAction type='outline'
                        onClick={this.onMobileBackClick}
                        starred={conversation.priority}
                        mobile={true}
                      >
                        <Icon icon='arrow-left' />
                      </HeaderAction>
                    </SimpleTooltip>
                    {t('Conversation::Messenger')}
                  </HeaderTitle>

                  <HeaderActions>
                    <SimpleTooltip content={conversation.priority ? t('Conversation::Remove priority') : t('Conversation::Mark priority')}>
                      <HeaderAction type='outline'
                        onClick={this.onTogglePriority}
                        starred={conversation.priority}
                      >
                        <Icon icon={conversation.priority ? 'star' : 'star-empty'} />
                      </HeaderAction>
                    </SimpleTooltip>

                    <SimpleTooltip content={conversation.state === ConversationState.CLOSED ? t('InboxView::Reopen') : t('InboxView::Close')}>
                      <HeaderAction
                        type='primary'
                        onClick={this.onToggleClosedClick}
                      >
                        <Icon icon={conversation.state === ConversationState.CLOSED ? 'archive-arrow-up' : 'archive-arrow-down'} />
                      </HeaderAction>
                    </SimpleTooltip>

                    {!conversationDetailsMenuActive && <SimpleTooltip content={t('InboxView::Show conversation details')}>
                      <HeaderAction
                        onClick={this.onToggleConversationDetailsMenu}
                      >
                        <Icon icon='menu-right' />
                      </HeaderAction>
                    </SimpleTooltip>}
                    {!conversationDetailsMobileMenuActive && <SimpleTooltip content={t('InboxView::Show conversation details')}>
                      <HeaderAction
                        onClick={this.onToggleConversationDetailsMenu}
                        mobile={true}
                      >
                        <Icon icon='menu-right' />
                      </HeaderAction>
                    </SimpleTooltip>}
                  </HeaderActions>
                </Header>

                <ConversationWrapper ref={this.wrapper} onScroll={this.onScroll}>
                  {Object.keys(groupedMessages).map((date, index) => {
                    const messages = groupedMessages[date]

                    return (
                      <>
                        <ConversationPart key={date} type='date'>
                          {moment(date).format('MMMM D')}
                        </ConversationPart>

                        {messages?.map((message, index) => {
                          const previousMessage = messages[index - 1]
                          const nextMessage = messages[index + 1]

                          const topRadius = previousMessage && previousMessage?.author?.type === message.author?.type
                          const bottomRadius = nextMessage && nextMessage?.author?.type === message.author?.type

                          return (
                            <ConversationPart key={message.id || message.client_assigned_id} type='message'>
                              <Message
                                message={message}
                                onPreviewClick={this.onPreviewAttachmentClick}
                                admin={true}
                                topRadius={topRadius}
                                bottomRadius={bottomRadius}
                                locale={conversation.user_data?.locale || widget.locale}
                              />
                            </ConversationPart>
                          )
                        })}
                      </>
                    )
                  })}
                </ConversationWrapper>

                <ConversationFooter messageType={messageType}>
                  <ConversationFooterWrapper>
                    <ConversationFooterTop>
                      <Popover
                        active={messageTypePopoverActive}
                        activator={<ConversationMessageTypeOption active={messageTypePopoverActive} onClick={this.onMessageTypePopoverToggle}>
                          {messageType === ConversationMessageType.TEXT && <>
                            <Icon icon='messenger-conversations-active' />
                            {t('InboxView::Reply')}
                          </>}
                          {messageType === ConversationMessageType.NOTE && <>
                            <Icon icon='messenger-note' />
                            {t('InboxView::Note')}
                          </>}

                          <Icon icon='chevron-down' />
                        </ConversationMessageTypeOption>}
                        onClose={this.onMessageTypePopoverClose}
                        placement='top'
                        strategy='fixed'
                      >
                        <MessageTypePopover
                          activeMessageType={messageType}
                          onMessageTypeSelect={this.onMessageTypeChange}
                        />
                      </Popover>

                    </ConversationFooterTop>

                    <ConversationFooterInput
                      ref={this.messageInput}
                      placeholder={t('Conversation::Message...')}
                      onChange={this.onMessageChange}
                      value={message}
                      onKeyDown={this.onMessageKeyDown}
                      onFocus={this.onMessageInputFocus}
                      onBlur={this.onMessageInputBlur}
                    />
                    <ConversationFooterActions>
                      <ConversationFooterLeftActions>
                        <ConversationFooterAction>
                          <Icon icon='bolt' />
                        </ConversationFooterAction>
                        <Popover
                          active={emojiPopoverActive}
                          activator={<ConversationFooterAction onClick={this.onEmojiPopoverToggle}>
                            <Icon icon='messenger-emoji' />
                          </ConversationFooterAction>}
                          onClose={this.onEmojiPopoverClose}
                          placement='top'
                          strategy='fixed'
                        >
                          <EmojiPopover
                            onEmojiSelect={this.onEmojiSelect}
                          />
                        </Popover>

                        <Popover
                          active={giphyPopoverActive}
                          activator={
                            <ConversationFooterAction onClick={this.onGiphyPopoverToggle}>
                              <Icon icon='messenger-gif' />
                            </ConversationFooterAction>
                          }
                          onClose={this.onGiphyPopoverClose}
                          placement='top'
                          strategy='fixed'
                        >
                          <GiphyPopover
                            onGifSelect={this.onGiphySelect}
                          />
                        </Popover>

                        {widget.help_center_id && <ConversationFooterAction onClick={this.onInsertArticleClick}>
                          <Icon icon='messenger-article' />
                        </ConversationFooterAction>}

                        <Dropzone
                          onDrop={this.onAttachmentDrop}
                          maxSize={20000000}
                          maxFiles={1}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <ConversationFooterAction {...getRootProps()}>
                              <input {...getInputProps()} />
                              <Icon icon='messenger-attachment' />
                            </ConversationFooterAction>
                          )}
                        </Dropzone>
                      </ConversationFooterLeftActions>

                      <ConversationFooterRightActions>
                        <SendButton disabled={message.length === 0} onClick={this.onMessageSendClick}>
                          <span>{t('Conversation::Send')}</span>
                        </SendButton>
                      </ConversationFooterRightActions>
                    </ConversationFooterActions>
                  </ConversationFooterWrapper>
                </ConversationFooter>
              </ConversationContent>

              <ConversationDetails
                active={conversationDetailsMenuActive}
                mobileActive={conversationDetailsMobileMenuActive}
              >
                <Header>
                  <HeaderTitle>
                    {t('Inbox::Details')}
                  </HeaderTitle>

                  <HeaderActions>
                    <SimpleTooltip content={t('InboxView::Hide conversation details')}>
                      <HeaderAction
                        onClick={this.onToggleConversationDetailsMenu}
                      >
                        <Icon icon='menu-right' />
                      </HeaderAction>
                    </SimpleTooltip>
                  </HeaderActions>
                </Header>

                <DetailsSection>
                  <DetailsSectionItem vertical>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Assignee')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue overflowVisible={true}>
                      <ResourceCreatablePowerSelect
                        type='user'
                        value={conversation.assignee_id}
                        onChange={this.onConversationAssigneeChange}
                        isClearable={true}
                        isValidNewOption={() => false}
                        placeholder='—'
                      />
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>
                </DetailsSection>

                <DetailsSection
                  icon='messenger-conversations-active'
                  title={t('InboxView::Conversation attributes')}
                >
                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::ID')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      {conversation.id}
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Contact')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      —
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Brand')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      <Badge type='grey' text={widget.name} />
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>
                </DetailsSection>

                <DetailsSection
                  icon='user'
                  title={t('InboxView::User data')}
                >
                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Contact')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      —
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Name')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      {conversation?.user_data?.name || '—'}
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Email')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      {conversation?.user_data?.email || '—'}
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Language')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      {conversation?.user_data?.locale ? t(`PublicLocale::${conversation.user_data.locale}`) : '—'}
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Location')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      {conversation?.user_data?.location || '—'}
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::User ID')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      {conversation?.user_data?.id || '—'}
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>

                  <DetailsSectionItem>
                    <DetailsSectionItemProperty>
                      {t('InboxView::Last seen')}
                    </DetailsSectionItemProperty>

                    <DetailsSectionItemValue>
                      {moment(conversation?.user_data?.last_seen_at).format('LLL') || '—'}
                    </DetailsSectionItemValue>
                  </DetailsSectionItem>
                </DetailsSection>
              </ConversationDetails>
            </ConversationContainer>
          </ActionCableConsumer>
        </ThemeProvider>

        <PreviewModal
          url={previewUrl}
          onClose={this.onPreviewAttachmentClose}
        />
      </>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser,
    }
  } = state

  return {
    currentUser: currentUser,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    showInsertArticleModal: (options) => dispatch(showInsertArticleModal(options)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Conversation))